export default __webpack_public_path__ + "static/media/portfolio_pic.f2f2193b.svg";